import { Injector } from '@angular/core';
import * as VERSION from '@environments/version';
import { MODULE_VERSION } from './token.version';
import * as i0 from "@angular/core";
export class VersionService {
    constructor(injector) {
        this.mustRefresh = false;
        this.ListOfRefreshed = [];
        const keyService = injector.get(MODULE_VERSION);
        const version = localStorage.getItem(keyService);
        if (version) {
            if (version === VERSION.VERSION.actual_version) {
            }
            else {
                this.mustRefresh = true;
                localStorage.setItem(keyService, VERSION.VERSION.actual_version);
            }
        }
        else {
            localStorage.setItem(keyService, VERSION.VERSION.actual_version);
        }
    }
    refresh(viewContainer) {
        if (this.mustRefresh) {
            viewContainer.refresh();
        }
    }
}
VersionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionService_Factory() { return new VersionService(i0.ɵɵinject(i0.INJECTOR)); }, token: VersionService, providedIn: "root" });
